import popper from 'popper.js'

import collapse_controller from "./collapse_controller";
import Popper from 'popper.js'

export default class extends collapse_controller  {
    popper

    /**
     * The controller has loaded.
     */
    connect() {
        super.connect()
        this.popper = new Popper(this.toggleTarget, this.collapseTarget, {
            placement: "top-end",
            removeOnDestroy: true,
            modifiers: {
                offset: {
                    offset: '0 15'
                },
                flip: {
                    enabled: false
                }
            }
        })
    }

    show()
    {

    }

    hide()
    {

    }

    /**
     * The controller has disconnected.
     */
    disconnect()
    {
        this.popper.destroy()
    }
}
